import { Fragment } from "react";
import { excerptSegments } from "../lib/excerpt";

/**
 * A search excerpt with its matches highlighted. Built from text nodes and `<mark>` elements —
 * the excerpt is never parsed as HTML, so markup planted in an article body shows as text.
 */
export function Excerpt({ text, markClassName }: { text: string; markClassName?: string }) {
  return (
    <>
      {excerptSegments(text).map((segment, index) =>
        segment.match ? (
          // oxlint-disable-next-line react/no-array-index-key -- segments are positional and never reorder
          <mark key={index} className={markClassName}>
            {segment.text}
          </mark>
        ) : (
          // oxlint-disable-next-line react/no-array-index-key -- as above
          <Fragment key={index}>{segment.text}</Fragment>
        ),
      )}
    </>
  );
}
